<template lang="pug">
  .fpui-store-list
    .search
      fpui-input-search(v-model='search')
    .row.items(:style='{ height: heightItems }')
      .item-container.col-lg-4.col-sm-6.col-xs-12.create-package(@click="$emit('create')")
        .item.create
          .create-wrapper
            p {{ createText }}
            i.fpui.fpui-plus
      fpui-list-item.item-container.col-lg-4.col-sm-6.col-xs-12(
        v-if='showItem(item)'
        @click="onSelect(item)"
        @edit="$emit('edit', item)"
        @editStore="$emit('editStore', item)"
        @buy="$emit('buy', item)"
        @install="$emit('install', item)"
        @remove="$emit('remove', item)"
        @detail="$emit('detail', item)"
        v-for="item, idx in orderedItems"
        :key="item.id"
        :item="item"
      )
</template>

<script>
  import get from 'lodash/get'
  import orderBy from 'lodash/orderBy'
  import FpuiListItem from './FpuiListItem'

  export default {
    name: 'FpuiListItems',
    components: { FpuiListItem },
    props: {
      type: { type: String, required: true },
      consumer: { type: String, required: true },
      items: { type: Array, required: true },
      category: { type: Object }
    },
    data () {
      return {
        search: ''
      }
    },
    computed: {
      installed () { return this.$store.state.packages.installed },
      createText () {
        let type
        if (this.consumer === 'ml' && this.type === 'modules') {
          type = this.$t('fpStore.packages.new.model')
        } else {
          type = this.$t(`fpStore.packages.new.${this.type}`)
        }
        return this.$t('fpStore.packages.new', [type])
      },
      orderedItems () {
        return orderBy(this.items, ['beta', 'installed', 'name'], ['desc', 'desc', 'asc'])
      },
      heightItems () {
        let height = 0
        let main = document.querySelector('main')
        if (main) {
          height = main.offsetHeight - 30 - 33 - 15
        }
        return `${height}px`
      }
    },
    methods: {
      onSelect (item) {
        if (this.$store.state.installed) return
        this.$emit('select', item)
      },
      showItem (item) {
        if (!get(this.installed, item.id) && item.hidden) return false
        if (!this.category) return true
        const itemCategories = Array.isArray(item.category) ? item.category : [item.category]
        if(itemCategories.includes('System') && this.category.value !== 'System') return false
        if (this.category.type === 'isInstalled') {
          if ((typeof get(this.installed, item.id) !== 'undefined') !== this.category.value) {
            return false
          }
        } else if (this.category.type === 'bool') {
          if (item[this.category.key] !== this.category.value) {
            return false
          }
        } else if (this.category.value !== 'all' && !itemCategories.filter(categ => categ.toLowerCase() === this.category.value.toLowerCase()).length) {
          return false
        }
        if (!this.search) return true
        let keys = ['id', 'category', 'name', 'description']
        for (let idx in keys) {
          let key = keys[idx]
          const value = Array.isArray(item[key]) ? item[key].join(', ') : item[key]
          if (item[key] && value.toLowerCase().includes(this.search.toLowerCase())) {
            return true
          }
        }
        return false
      }
    }
  }
</script>

<style lang="less">
  @import "~@/shared/styles/_variables.less";

  .fpui-store-list {
    .search {
      margin-bottom: 15px;
    }
    .items {
      width: 100%;
      margin: 0;
      overflow: auto;
      .item-container {
        padding: 5px;
        .create {
          height:120px;
          padding: 10px;
          position: relative;
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          border: 2px solid white;
          transition: all 0.25s;
          text-align: center;
          font-size:20px;
          color:#bbb;
          .create-wrapper {
            position: absolute;
            width: 75%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          &:hover, &.active {
            border-color: @blue;
            background-color: @blueLight;
            .item-informations {
              .item-description:after {
                background-color: @blueLight;
              }
            }
          }
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
</style>
